<template>
	<v-dialog
			v-model="showDialog_"
			persistent
			width="1050px">
		<template v-slot:activator="{ on }">
			<v-btn v-on="on">
				<v-row no-gutters align="end">
					<v-col class="center">
						<v-icon>build</v-icon>
					</v-col>
					<v-col class="ml-2 center">
						<span class="button_">COMPONENT</span>
					</v-col>
				</v-row>
			</v-btn>
		</template>
		<v-card class="customVCard">
			<v-card-title>
				<v-row class="pt-2" justify="center">
					<v-col cols="auto">
						COMPONENT BUILDER
					</v-col>
				</v-row>
			</v-card-title>
			<v-card-text>
				<!-- tab -->
				<v-row class="px-2" align="center">
					<v-col cols="auto">
						<v-select
								class="select_"
								v-model="selectedCategory_"
								color="success"
								dense
								hide-details
								outlined
								:items="categories_" />
					</v-col>
					<v-col>
						<v-tabs	v-model="selectedTab_"
								color="success">
							<template v-for="key in tabs_">
								<v-tab :key="key" v-text="key" />
							</template>
						</v-tabs>
					</v-col>
				</v-row>
				<!-- item -->
				<v-row class="px-2" align="center">
					<!-- combobox -->
					<v-col>
						<!-- inits -->
						<template v-if="selectedTab_ == 0">
							<v-select
									v-model="selectedItem_"
									color="success"
									:items="items_[selectedTab_]" />
						</template>
						<!-- contents & langs & styles -->
						<template v-else-if="(selectedTab_ == 1)">
							<v-combobox
									v-model="selectedItem_"
									color="success"
									:items="items_[selectedTab_]" />
						</template>
					</v-col>
					<!-- build button -->
					<v-col cols="auto">
						<v-btn	color="success"
								:disabled="!selectedItem_"
								icon
								small
								@click="$_bldrCmptDlg_setParams()">
							<v-icon>build</v-icon>
						</v-btn>
					</v-col>
					<!-- code button -->
					<v-col cols="auto">
						<v-dialog
								v-model="showDialogJSON_"
								persistent
								width="750px">
							<template v-slot:activator="{ on }">
								<v-btn	color="success"
										:disabled="!selectedItem_"
										icon
										@click="$_bldrCmptDlg_openTextarea(on)">
									<v-icon>code</v-icon>
								</v-btn>
							</template>
							<v-card class="customVCard">
								<v-card-text>
									<v-textarea v-model="paramsJSON_" />
								</v-card-text>
								<v-card-actions>
									<v-row dense justify="center">
										<v-col cols="auto">
											<v-btn	color="success"
													@click="$_bldrCmptDlg_updateParamsWithJSON()">
												Set
											</v-btn>
										</v-col>
										<v-col cols="auto">
											<v-btn	color="secondary"
													@click="$_bldrCmptDlg_closeTextarea()">
												Cancel
											</v-btn>
										</v-col>
									</v-row>
								</v-card-actions>
							</v-card>
						</v-dialog>
					</v-col>
				</v-row>
				<!-- params -->
				<template v-for="(paramVal, paramKey) in sortObject(paramsLeft_)">
					<v-row class="px-2" :key="paramKey">
						<v-col cols="3">
							<v-alert
									class="customVAlert"
									color="success"
									outlined>
								<span	class="caption dev_"
										v-text="paramKey" />
							</v-alert>
						</v-col>
						<v-col cols="3">
							<v-alert
									class="customVAlert"
									color="success"
									outlined>
								<pre	class="prettyprint caption pretty_ dev_"
										v-text="paramVal" />
							</v-alert>
						</v-col>
						<v-col class="px-0" cols="auto">
							<v-btn	color="success"
									icon
									@click="$_bldrCmptDlg_updateParams(paramKey)">
								<v-icon>keyboard_arrow_left</v-icon>
							</v-btn>
						</v-col>
						<v-col>
							<v-alert
									class="customVAlert pa-3"
									color="success"
									outlined>
								<template v-if="isBoolean(paramsLeft_[paramKey])">
									<v-switch
											class="ma-1 label_"
											v-model="paramsRight_[paramKey]"
											color="success"
											dense
											hide-details />
								</template>
								<template v-else>
									<v-textarea
											class="ma-1 prettyprint caption pretty_"
											v-model="paramsRight_[paramKey]"
											auto-grow
											color="success"
											dense
											hide-details
											rows="1" />
								</template>
							</v-alert>
						</v-col>
						<template v-if="paramKey == 'text'">
							<v-col class="pl-0 center" cols="auto">
								<v-btn	color="success"
										icon
										@click="openLink({ url: 'https://colab.research.google.com/drive/11-Ks7-epfw_oIOaFKDpsCT1BUze-yMoQ' })">
									<v-icon>developer_mode</v-icon>
								</v-btn>
							</v-col>
						</template>
					</v-row>
				</template>
			</v-card-text>
			<v-card-actions>
				<!-- buttons -->
				<v-row class="px-2 pb-3" justify="center" dense>
					<v-col cols="auto">
						<v-btn	color="success"
								:disabled="!paramsUpdated_ || !selectedItem_"
								large
								@click="$_bldrCmptDlg_save(false)">
							<template v-if="isFalse(onProgress_)">
								Save
							</template>
							<template v-else>
								<progress-circular />
							</template>
						</v-btn>
					</v-col>
					<v-col cols="auto">
						<v-btn	color="success"
								:disabled="!paramsUpdated_ || !selectedItem_"
								large
								@click="$_bldrCmptDlg_save(true)">
							<template v-if="isFalse(onProgress_)">
								Save & Reload
							</template>
							<template v-else>
								<progress-circular />
							</template>
						</v-btn>
					</v-col>
					<v-col cols="auto">
						<v-btn	color="secondary"
								large
								@click="$_bldrCmptDlg_close()">
							Close
						</v-btn>
					</v-col>
				</v-row>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>

<script>
	export default {
		name: 'BuilderComponentDialog',
		data() {
			return {
				showDialog_: false,
				showDialogJSON_: false,
				// category
				categories_: [
					'chatList',
					'menuList',
					'messagebarAnonymousForm',
					'messagebarFooter',
					'progressCircular',
					'progressLinear',
					'searchbarList',
					'settingList',
					'settingNavigationDrawer',
					'timelineMessageBodyCard',
					'timelineMessageHeaderCard',
					'toolbar',
					'toolbarTabs',
					'versionInfoFooter'
				],
				selectedCategory_: null,
				// tab
				tabs_: [ 'inits', 'contents' ],
				selectedTab_: 0,
				// item
				items_: [
					// inits
					[ 'info', 'lang', 'link', 'style' ],
					// contents
					[]
				],
				selectedItem_: null,
				// state
				state_: [
					// inits state
					{
						info: {},
						lang: {},
						link: {},
						style: {}
					},
					// contents state
					{ new: {} }
				],
				// params
				paramsLeft_: {},
				paramsRight_: {},
				paramsJSON_: null,
				paramsUpdated_: false,
				// save button
				onProgress_: false
			}
		},
		computed: {
			// state
			$_bldrCmptDlg_stateAppIsMobileScreen() {
				const self_ = this;
				return self_.getAppState('isMobileScreen')
			}
		},
		watch: {
			selectedCategory_: function(category) {
				const self_ = this;

				if(!self_.isFalse(category)) {
					self_.$_bldrCmptDlg_setInitsState()
					self_.$_bldrCmptDlg_setContentsState()
				}
			}
		},
		created() {
			const self_ = this;

			self_.$_bldrCmptDlg_reset()
		},
		methods: {
			$_bldrCmptDlg_setInitsState() {
				const self_ = this;
				
				const inits_ = self_.getComponentInits(self_.selectedCategory_) || self_.getComponentInits('default_')

				self_.state_[0] = inits_;
			},
			$_bldrCmptDlg_setContentsState() {
				const self_ = this;

				const contents_ = self_.getComponentContents(self_.selectedCategory_) || self_.getComponentContents('default_')

				self_.items_[1] = Object.keys(contents_)
				self_.state_[1] = contents_;
			},
			$_bldrCmptDlg_setParams() {
				const self_ = this;

				self_.paramsLeft_ = self_.parseObject(self_.state_[self_.selectedTab_][self_.selectedItem_])
				self_.paramsRight_ = {}
				self_.paramsUpdated_ = false;

				Object.keys(self_.paramsLeft_).forEach(key => {
					// object
					if(self_.isObject(self_.paramsLeft_[key]) || JSON.stringify(self_.paramsLeft_[key]) == '{}') {
						self_.paramsRight_[key] = JSON.stringify(self_.paramsLeft_[key])
					// boolean
					} else if(self_.isBoolean(self_.paramsLeft_[key])) {
						if(self_.paramsLeft_[key]) { self_.paramsRight_[key] = 1 }
						else { self_.paramsRight_[key] = 0 }
					// null
					} else if(self_.isFalse(self_.paramsLeft_[key])) {
						self_.paramsRight_[key] = 'NULL';
					// text & number
					} else {
						self_.paramsRight_[key] = self_.paramsLeft_[key]
					}
				})
			},
			$_bldrCmptDlg_updateParams(key) {
				const self_ = this;

				// inits & contents
				if(self_.selectedTab_ == 0 || self_.selectedTab_ == 1) {
					// object
					if(self_.isObject(self_.paramsLeft_[key]) || JSON.stringify(self_.paramsLeft_[key]) == '{}') {
						self_.paramsLeft_[key] = JSON.parse(self_.paramsRight_[key])
					// boolean
					} else if(self_.isBoolean(self_.paramsLeft_[key])) {
						if(self_.paramsRight_[key] == 0) { self_.paramsLeft_[key] = false }
						else { self_.paramsLeft_[key] = true }
					// null
					} else if(self_.paramsRight_[key].toLowerCase() == 'null') {
						self_.paramsLeft_[key] = null;
					// text & number
					} else {
						if(self_.isNumber(self_.paramsLeft_[key])) {
							self_.paramsLeft_[key] = Number(self_.paramsRight_[key])
						} else {
							self_.paramsLeft_[key] = self_.paramsRight_[key]
						}
					}
				}
				// langs & styles
				else if(self_.selectedTab_ == 2 || self_.selectedTab_ == 3) {
					const param_ = self_.paramsRight_[key]
					// object
					if(param_.substr(0, 1) == '{') {
						self_.paramsLeft_[key] = JSON.parse(param_)
					}
					// string
					else {
						self_.paramsLeft_[key] = param_;
					}
				}

				self_.paramsUpdated_ = true;
			},
			$_bldrCmptDlg_openTextarea() {
				const self_ = this;
				self_.paramsJSON_ = JSON.stringify(self_.paramsLeft_)
				self_.showDialogJSON_ = true;
			},
			$_bldrCmptDlg_closeTextarea() {
				const self_ = this;
				self_.showDialogJSON_ = false;
			},
			$_bldrCmptDlg_updateParamsWithJSON() {
				const self_ = this;

				self_.paramsLeft_ = JSON.parse(self_.paramsJSON_)
				self_.paramsUpdated_ = true;	

				self_.showDialogJSON_ = false;
			},
			$_bldrCmptDlg_save(reload) {
				const self_ = this;

				self_.onProgress_ = true;

				const type_ = self_.tabs_[self_.selectedTab_];

				let key_ = null;
				if(self_.selectedItem_ == 'new') { key_ = self_.getChanceDocumentKey() }
				else { key_ = self_.selectedItem_; }

				Promise.resolve().then(() => {
					return self_.setFirestoreSubDocument(type_, 'component', self_.selectedCategory_, key_, self_.paramsLeft_)						
				}).then(() => {
					if(reload) {
						self_.openLink({ method: { name: 'reload' }})
					} else {
						self_.$_bldrCmptDlg_reset()
					}
				}).catch(error => {
					console.log(error)
				})
			},
			$_bldrCmptDlg_reset() {
				const self_ = this;

				self_.paramsLeft_ = {}
				self_.paramsRight_ = {}
				self_.paramsJSON_ = null;
				self_.paramsUpdated_ = false;

				self_.onProgress_ = false;
				self_.showDialogJSON_ = false;

				if(!self_.isFalse(self_.selectedCategory_)) {
					self_.$_bldrCmptDlg_setInitsState()
					self_.$_bldrCmptDlg_setContentsState()
				}
			},
			$_bldrCmptDlg_close() {
				const self_ = this;

				self_.showDialog_ = false;

				self_.selectedCategory_ = null;
				self_.selectedTab_ = 0;
				self_.selectedItem_ = null;

				self_.$_bldrCmptDlg_reset()
			}
		}
	}
</script>

<style scoped>
	.button_ {
		font-size: xx-small !important;
	}
	.title_ {
		color: #ff5252;
	}
	.radio_ {
		margin-top: 20px;
		margin-bottom: 0 !important;
	}
	.mergin_ {
		margin-top: 0;
		margin-bottom: 0;
	}
	.pretty_ {
		border: none;
	}
	.debug_ {
		color: #ff5252;
	}
	.dev_ {
		color: #4caf50;
	}
</style>
